import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import 'react-datepicker/dist/react-datepicker.css';

import InfluencerUsersAnalyticsHome from './users/InfluencerUsersAnalyticsHome';

import styles from './InfluencerAnalyticsHome.module.scss';

const InfluencerAnalyticsHome = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const renderSwitch = tab => {
    switch (tab) {
      case 0:
        return <InfluencerUsersAnalyticsHome />;

      default:
        return null;
    }
  };

  return (
    <div className={styles.content}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div>
            <Typography className={styles.title} variant="h6" gutterBottom>
              Analytics
            </Typography>
          </div>
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={selectedTab}
            onChange={(evt, value) => {
              setSelectedTab(value);
            }}
            variant="fullWidth"
            scrollButtons="on"
          >
            <Tab className={styles.tabAnalytics} label="Users" />
          </Tabs>
          {renderSwitch(selectedTab)}
        </Grid>
      </Grid>
    </div>
  );
};

export default InfluencerAnalyticsHome;
